import { FC, useEffect, useMemo, useState } from "react";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./per-product-chart.scss";
import { useDispatch, useSelector } from "react-redux";

import { Chart } from "primereact/chart";
import ChartWrapper from "../chart-wrapper/chart-wrapper";
import { getICProductConsumptionInPeriod, getICProductConsumptionInPeriodPerProduct } from "../../productSlices";

interface PerProductChartProps {
    dates: any;
    type: PerProductChartType;
    }

export enum PerProductChartType {
    TOP_5 = 'top_5',
    PER_PRODUCT = 'per_product'
}   
const PerProductChart:FC<PerProductChartProps> = ({dates, type}) => {
    const dispatch: Function = useDispatch();
    const user = useSelector((state: any) => state.auth.user);
    const selectedShop = useSelector((state: any) => state.user.selectedShop);
    const [perProductOptions, setPerProductOptions] = useState({});
    const [perProductData, setPerProductData] = useState({});

    const ic_products_top_5 = useSelector((state: any) => state.product.ic_products_consumption_top_5);
    const ic_product_consumption_per_product = useSelector((state: any) => state.product.ic_product_consumption_per_product_top_5);
    const height = useMemo(() => {
        return type === PerProductChartType.TOP_5 ? '30vh' : '20vh'
    }, [type])
    useEffect(() => {
        if(!dates || !dates[0] || !dates[1]) return
        if (type === PerProductChartType.TOP_5) {
            dispatch(getICProductConsumptionInPeriod(selectedShop, dates[0].toDateString().toString(), dates[1].toDateString().toString()))
        } else if (type === PerProductChartType.PER_PRODUCT) {

            dispatch(getICProductConsumptionInPeriodPerProduct(selectedShop, dates[0].toDateString().toString(), dates[1].toDateString().toString()))
        }
    },[selectedShop, dates, type])
    
    useEffect(() => {
        const productData = type === PerProductChartType.TOP_5 ? ic_products_top_5 : ic_product_consumption_per_product;
        if(!productData || !productData.length) return;

        const values = productData.map((product: any) => product.total_liters)
        const data = {
            labels: productData.map((product: any)=>product.name),
            datasets: [{
                label:'Liters',
                backgroundColor: '#585BFF',
                borderRadius: 3,
                borderColor: '#585BFF',
                data: values
            }] 
        };

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    display:false
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: 'black',
                        font: {
                            weight: 'bold',
                            size:12
                        }
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: '#696969'
                    },
                    grid: {
                        display:false
                    },
                    max: Math.round(Math.max(...values) * 1.1)
                }
            }
        };
        setPerProductData(data);
        setPerProductOptions(options);
    }, [ic_products_top_5, ic_product_consumption_per_product, type]);

 return (
    <div className='per-product-chart'>
        <Chart type="bar" data={perProductData} width="30vw" height={height} options={perProductOptions} />
      </div>
  );
};

export default PerProductChart;
